import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
  noindex?: boolean;
  schema?: Record<string, any>;
}

const defaultSEO = {
  title: '搬家公司推薦｜新北台北搬家服務｜建鈞精緻搬家 0978-900-081',
  description: '搬家服務推薦建鈞精緻搬家，新北市搬家公司推薦首選，提供台北搬家、桃園搬家、新竹搬家服務。專業套房搬遷、家庭搬家、辦公室搬遷、廢棄物清運、垃圾處理。24小時服務，立即撥打0978-900-081或加LINE @285yavdh免費諮詢報價。',
  keywords: '搬家公司推薦,新北搬家公司,台北搬家公司,搬家服務,桃園搬家,新竹搬家,套房搬家,家庭搬家,辦公室搬遷,廢棄物處理,垃圾清運,人力搬工,搬家費用,24小時搬家,搬家估價,免費估價',
  ogImage: 'https://public.readdy.ai/ai/img_res/c9570e0c1f20c9100bb262628a2de5ae.jpg'
};

// 頁面特定 SEO 配置
const pageSEO: Record<string, SEOProps> = {
  '/': {
    title: '搬家公司推薦｜新北台北搬家服務｜建鈞精緻搬家 0978-900-081',
    description: '搬家服務推薦建鈞精緻搬家，新北市搬家公司推薦首選，提供台北搬家、桃園搬家、新竹搬家服務。專業套房搬遷、家庭搬家、辦公室搬遷、廢棄物清運、垃圾處理。24小時服務，立即撥打0978-900-081或加LINE @285yavdh免費諮詢報價。',
    keywords: '搬家公司推薦,新北搬家公司,台北搬家公司,搬家服務,桃園搬家,新竹搬家,套房搬家,家庭搬家,辦公室搬遷,廢棄物處理,垃圾清運,人力搬工,搬家費用,24小時搬家,搬家估價,免費估價',
    ogImage: defaultSEO.ogImage,
    ogType: 'website'
  },
  '/about': {
    title: '搬家公司介紹｜建鈞精緻搬家｜新北台北專業搬家團隊',
    description: '搬家公司推薦建鈞精緻搬家，擁有10年搬家經驗，專業團隊提供新北市、台北市、桃園市、新竹市搬家服務。透明收費、24小時服務、客戶好評推薦。立即撥打0978-900-081了解更多。',
    keywords: '搬家公司介紹,建鈞搬家,專業搬家團隊,新北搬家推薦,搬家經驗',
    ogType: 'website'
  },
  '/services': {
    title: '搬家服務項目｜套房辦公室搬遷｜建鈞精緻搬家 0978-900-081',
    description: '搬家服務推薦建鈞精緻搬家，提供新北市、台北市、桃園市、新竹市專業搬家服務：套房搬遷、辦公室搬遷、廢棄物處理、精緻包裝、鋼琴搬運、家具拆裝等。24小時接單，免費估價，立即撥打0978-900-081。',
    keywords: '搬家服務項目,套房搬家,辦公室搬遷,廢棄物處理,精緻包裝,鋼琴搬運,家具拆裝,搬家公司推薦',
    ogType: 'website'
  },
  '/pricing': {
    title: '搬家費用價格｜新北台北搬家價目表｜建鈞精緻搬家收費標準',
    description: '搬家費用透明公開，建鈞搬家提供新北搬家、台北搬家價格標準，套房搬家、辦公室搬遷、廢棄物處理等服務價格清楚明確。免費到府估價，立即聯繫0978-900-081或LINE @285yavdh。',
    keywords: '搬家費用,搬家價格,搬家價目表,搬家收費標準,免費估價,搬家報價,新北搬家費用,台北搬家價格',
    ogType: 'website'
  },
  '/cases': {
    title: '搬家案例分享｜成功實例｜建鈞精緻搬家客戶評價推薦',
    description: '搬家案例分享，查看建鈞搬家的成功案例，包含套房搬家、辦公室搬遷、鋼琴搬運等實際服務案例。新北市、台北市、桃園市、新竹市客戶真實評價，專業團隊值得信賴。立即預約0978-900-081。',
    keywords: '搬家案例,搬家實例,客戶評價,搬家推薦,成功案例分享,搬家公司推薦',
    ogType: 'website'
  },
  '/contact': {
    title: '搬家公司聯絡｜免費估價預約｜建鈞精緻搬家 0978-900-081',
    description: '搬家服務諮詢，立即聯繫建鈞搬家，提供新北市、台北市、桃園市、新竹市24小時搬家服務。電話：0978-900-081，LINE ID：@285yavdh。免費到府估價，專業團隊為您服務。',
    keywords: '搬家公司聯絡,聯絡搬家公司,搬家預約,免費估價,搬家諮詢,搬家電話,搬家LINE',
    ogType: 'website'
  },
  '/quote': {
    title: '搬家免費估價｜線上報價服務｜建鈞精緻搬家 0978-900-081',
    description: '搬家免費估價，建鈞搬家提供免費線上估價服務，填寫表單即可快速獲得搬家報價。服務範圍涵蓋新北市、台北市、桃園市、新竹市。24小時接單，專業團隊，立即填寫或撥打0978-900-081。',
    keywords: '搬家免費估價,免費估價,搬家報價,線上估價,搬家諮詢,快速報價',
    ogType: 'website'
  },
  '/service-area': {
    title: '搬家服務範圍｜新北台北桃園新竹｜建鈞精緻搬家服務區域',
    description: '搬家服務範圍涵蓋新北市、台北市、桃園市、新竹市、基隆市、台中市、台南市、高雄市、彰化縣等地區。24小時搬家服務，專業團隊，立即預約0978-900-081。',
    keywords: '搬家服務範圍,服務區域,新北搬家,台北搬家,桃園搬家,新竹搬家',
    ogType: 'website'
  },
  '/knowledge': {
    title: '搬家知識技巧｜搬家注意事項｜建鈞精緻搬家攻略大全',
    description: '搬家知識分享，提供實用的搬家技巧、打包方法、注意事項等資訊。幫助您輕鬆完成搬家準備，新北市、台北市、桃園市、新竹市專業搬家服務，立即諮詢0978-900-081。',
    keywords: '搬家知識,搬家技巧,搬家注意事項,打包方法,搬家準備,搬家攻略',
    ogType: 'website'
  },
  '/faq': {
    title: '搬家常見問題｜FAQ 疑問解答｜建鈞精緻搬家諮詢服務',
    description: '搬家常見問題解答，包含搬家費用、服務流程、注意事項等。新北市、台北市、桃園市、新竹市專業搬家服務，24小時接單，立即諮詢0978-900-081或LINE @285yavdh。',
    keywords: '搬家常見問題,搬家FAQ,搬家疑問,搬家解答,搬家諮詢',
    ogType: 'website'
  },
  '/area/taipei': {
    title: '台北市搬家｜台北搬家公司推薦｜建鈞精緻搬家 0978-900-081',
    description: '台北市搬家推薦建鈞精緻搬家，提供台北市全區搬家服務，包含中正區、大同區、中山區、松山區、大安區、萬華區、信義區、士林區、北投區、內湖區、南港區、文山區。24小時服務，免費估價，立即預約0978-900-081。',
    keywords: '台北市搬家,台北搬家,台北搬家公司,台北搬家推薦,台北搬家服務',
    ogType: 'website'
  },
  '/area/new-taipei': {
    title: '新北市搬家｜新北搬家公司推薦｜建鈞精緻搬家 0978-900-081',
    description: '新北市搬家推薦建鈞精緻搬家，提供新北市全區搬家服務，包含板橋、三重、中和、永和、新莊、新店、土城、蘆洲、樹林、汐止、淡水等地區。24小時服務，免費估價，立即預約0978-900-081。',
    keywords: '新北市搬家,新北搬家,新北搬家公司,新北搬家推薦,板橋搬家,新莊搬家,中和搬家',
    ogType: 'website'
  },
  '/area/taoyuan': {
    title: '桃園市搬家｜桃園搬家公司推薦｜建鈞精緻搬家 0978-900-081',
    description: '桃園市搬家推薦建鈞精緻搬家，提供桃園市全區搬家服務，包含桃園區、中壢區、平鎮區、八德區、楊梅區、蘆竹區、龜山區等地區。24小時服務，免費估價，立即預約0978-900-081。',
    keywords: '桃園市搬家,桃園搬家,桃園搬家公司,桃園搬家推薦,中壢搬家',
    ogType: 'website'
  },
  '/area/hsinchu': {
    title: '新竹市搬家｜新竹搬家公司推薦｜建鈞精緻搬家 0978-900-081',
    description: '新竹市搬家推薦建鈞精緻搬家，提供新竹市全區搬家服務，包含東區、北區、香山區等地區。24小時服務，免費估價，立即預約0978-900-081或LINE @285yavdh。',
    keywords: '新竹市搬家,新竹搬家,新竹搬家公司,新竹搬家推薦,新竹搬家服務',
    ogType: 'website'
  },
  '/area/taichung': {
    title: '台中市搬家｜台中搬家公司推薦｜建鈞精緻搬家 0978-900-081',
    description: '台中市搬家推薦建鈞精緻搬家，提供台中市全區搬家服務，包含中區、東區、西區、南區、北區、西屯區、南屯區、北屯區等地區。24小時服務，免費估價，立即預約0978-900-081。',
    keywords: '台中市搬家,台中搬家,台中搬家公司,台中搬家推薦,台中搬家服務',
    ogType: 'website'
  },
  '/area/tainan': {
    title: '台南市搬家｜台南搬家公司推薦｜建鈞精緻搬家 0978-900-081',
    description: '台南市搬家推薦建鈞精緻搬家，提供台南市全區搬家服務，包含中西區、東區、南區、北區、安平區、安南區等地區。24小時服務，免費估價，立即預約0978-900-081。',
    keywords: '台南市搬家,台南搬家,台南搬家公司,台南搬家推薦,台南搬家服務',
    ogType: 'website'
  },
  '/area/kaohsiung': {
    title: '高雄市搬家｜高雄搬家公司推薦｜建鈞精緻搬家 0978-900-081',
    description: '高雄市搬家推薦建鈞精緻搬家，提供高雄市全區搬家服務，包含新興區、前金區、苓雅區、鹽埕區、鼓山區、旗津區、前鎮區、三民區、左營區等地區。24小時服務，免費估價，立即預約0978-900-081。',
    keywords: '高雄市搬家,高雄搬家,高雄搬家公司,高雄搬家推薦,高雄搬家服務',
    ogType: 'website'
  },
  '/area/changhua': {
    title: '彰化縣搬家｜彰化搬家公司推薦｜建鈞精緻搬家 0978-900-081',
    description: '彰化縣搬家推薦建鈞精緻搬家，提供彰化縣全區搬家服務，包含彰化市、員林市、和美鎮、鹿港鎮等地區。24小時服務，免費估價，立即預約0978-900-081。',
    keywords: '彰化縣搬家,彰化搬家,彰化搬家公司,彰化搬家推薦,彰化搬家服務',
    ogType: 'website'
  },
  '/area/keelung': {
    title: '基隆市搬家｜基隆搬家公司推薦｜建鈞精緻搬家 0978-900-081',
    description: '基隆市搬家推薦建鈞精緻搬家，提供基隆市全區搬家服務，包含仁愛區、信義區、中正區、中山區、安樂區、暖暖區、七堵區等地區。24小時服務，免費估價，立即預約0978-900-081。',
    keywords: '基隆市搬家,基隆搬家,基隆搬家公司,基隆搬家推薦,基隆搬家服務',
    ogType: 'website'
  },
  '/area/miaoli': {
    title: '苗栗縣搬家｜苗栗搬家公司推薦｜建鈞精緻搬家 0978-900-081',
    description: '苗栗縣搬家推薦建鈞精緻搬家，提供苗栗縣全區搬家服務，包含苗栗市、頭份市、竹南鎮、後龍鎮等地區。24小時服務，免費估價，立即預約0978-900-081。',
    keywords: '苗栗縣搬家,苗栗搬家,苗栗搬家公司,苗栗搬家推薦,苗栗搬家服務',
    ogType: 'website'
  },
  '/area/yilan': {
    title: '宜蘭縣搬家｜宜蘭搬家公司推薦｜建鈞精緻搬家 0978-900-081',
    description: '宜蘭縣搬家推薦建鈞精緻搬家，提供宜蘭縣全區搬家服務，包含宜蘭市、羅東鎮、蘇澳鎮、礁溪鄉等地區。24小時服務，免費估價，立即預約0978-900-081。',
    keywords: '宜蘭縣搬家,宜蘭搬家,宜蘭搬家公司,宜蘭搬家推薦,宜蘭搬家服務',
    ogType: 'website'
  }
};

export const useSEO = (customSEO?: SEOProps) => {
  const location = useLocation();

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.jjmoving.com.tw';
    const currentPath = location.pathname;
    
    // 獲取當前頁面的 SEO 配置
    const pageSEOConfig = pageSEO[currentPath] || {};
    const seo = { ...defaultSEO, ...pageSEOConfig, ...customSEO };

    // 更新 title
    document.title = seo.title || defaultSEO.title;

    // 更新或創建 meta 標籤的輔助函數
    const updateMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // 更新基本 meta 標籤
    if (seo.description) {
      updateMetaTag('description', seo.description);
    }

    if (seo.keywords) {
      updateMetaTag('keywords', seo.keywords);
    }

    // 更新 robots meta
    if (seo.noindex) {
      updateMetaTag('robots', 'noindex, nofollow');
    } else {
      updateMetaTag('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    }

    // 更新 canonical URL
    const canonicalUrl = seo.canonical || `${siteUrl}${currentPath}`;
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = canonicalUrl;

    // 更新 Open Graph 標籤
    updateMetaTag('og:title', seo.title || defaultSEO.title, true);
    updateMetaTag('og:description', seo.description || defaultSEO.description, true);
    updateMetaTag('og:url', canonicalUrl, true);
    updateMetaTag('og:type', seo.ogType || 'website', true);
    
    if (seo.ogImage) {
      updateMetaTag('og:image', seo.ogImage, true);
    }

    // 更新 Twitter Card 標籤
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', seo.title || defaultSEO.title);
    updateMetaTag('twitter:description', seo.description || defaultSEO.description);
    
    if (seo.ogImage) {
      updateMetaTag('twitter:image', seo.ogImage);
    }

    // 更新 last-modified
    const lastModified = new Date().toISOString().split('T')[0];
    updateMetaTag('last-modified', lastModified);

    // 更新或創建 Schema.org JSON-LD
    if (seo.schema) {
      let schemaScript = document.querySelector('script[type="application/ld+json"]#page-schema');
      
      if (!schemaScript) {
        schemaScript = document.createElement('script');
        schemaScript.setAttribute('type', 'application/ld+json');
        schemaScript.setAttribute('id', 'page-schema');
        document.head.appendChild(schemaScript);
      }

      // 添加 @context 和 url
      const schemaWithContext = {
        '@context': 'https://schema.org',
        ...seo.schema,
        url: canonicalUrl
      };

      schemaScript.textContent = JSON.stringify(schemaWithContext);
    }

  }, [location, customSEO]);
};

export default useSEO;
